<template>
  <div class="communication-content">
    <div class="app-header">活跃健全的内容，面向开发者的一站式学习交流平台</div>
    <div class="communication-card">
      <!-- 资源中心 -->
      <div class="card-content">
        <div v-for="(item, index) in list" :key="index">
          <div v-if="activateIndex == index" class="card-enter-active">
            <activateCard :list="item" :style="{ marginRight: `${index != 3 ? '16px' : ''}` }" />
          </div>
          <div v-else style="margin-right: 16px" class="card-leave-active" @mouseenter="handlemouse(item, index)">
            <card :list="item" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import activateCard from "./activateCard.vue";
import card from "./card.vue";
export default {
  components: {
    activateCard,
    card,
  },
  data() {
    return {
      activateIndex: 0,
      list: [
        {
          name: "资源中心",
          desc: "面向工业互联网学习人员及平台开发者",
          url: require("@/assets/images/website/home/ziyuan.png"),
          label: [
            {
              title: "文档中心",
              detail:
                "结合开发者常用场景进行使用指导，引导开发者快速平台使用，包含隶属于不同产品、不同版本的介绍、使用指南、案例文档等",
            },
            {
              title: "视频中心",
              detail:
                "为开发者提供常用场景的指导体验，视频内容包含：平台介绍、代码开发、使用工具、解决方案等",
            },
            {
              title: "下载中心",
              detail:
                "针对不同层面的开发者（低代码、高代码、集成）在开发过程中需要使用SDK、工具集、相关组件等",
            },
          ],
          path: `${window.DOMAIN_CONFIG.devc}/devc/contentCenter/index`
        },
        {
          name: "云学堂",
          desc: "面向工业互联网学习人员及平台开发者的学习、考试平台",
          url: require("@/assets/images/website/home/yunxuetang.png"),
          path: `${window.DOMAIN_CONFIG.devc}/devc/train`,
          label: [
            {
              title: "在线课程",
              detail: "涵盖云、AI、大数据、IoT等领域， 轻松又高效的知识学习",
            },
            {
              title: "学习路径",
              detail: "循序渐进的学习体系，助您开启云上 热门技术进阶之旅",
            },
            {
              title: "资格认证",
              detail: "一站式在线学练考，零基础学习前沿 技术，考取权威证书",
            }
          ],
        },
        {
          name: "开源社区",
          desc: "面向工业互联网学习人员及平台开发者的行业知识、业务知识、技术知识的分享平台",
          url: require("@/assets/images/website/home/kaiyuan.png"),
          path: `${window.DOMAIN_CONFIG.devc}/devc/problem`,
          label: [
            {
              title: "问题求助",
              detail:
                "开发者可发布问题，专家技术布道，精准高效，解决开发过程中的难题与疑虑",
            },
            {
              title: "精品问答",
              detail:
                "包含平台及相关开发过程中遇到的常见问题，精细化分类，方便开发者快速定位",
            },
          ],
        },
        {
          name: "开放平台",
          desc: "面向开发者的能力开放平台，旨在为合作伙伴提供应用分发、开发支持、技术协同等一站式服务",
          url: require("@/assets/images/website/home/kaifang.png"),
          path: window.DOMAIN_CONFIG.open + "/open",
          label: [
            {
              title: "沙箱实验室",
              detail: "一键预置实验资源，实验手册贴心 指导操作，量级轻、上手快",
            },
            {
              title: "APIs",
              detail:
                "依托于平台提供的低代码工具，LCDP，对象模型等，可以通过拖拽的方式快速构建工业APP 的过程",
            },
            {
              title: "开发服务",
              detail:
                "为开发者提供沙箱环境，APP集成，数据采集管理服务，协助开发者在开发过程中的集成开发",
            },
            {
              title: "开发工具",
              detail:
                "丰富的开发工具下载，帮助开发者快速开发集成，提升开发效率",
            },
          ],
        },
      ],
    };
  },
  methods: {
    handlemouse(item, index) {
      this.activateIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
.communication-content {
  width: 100%;
  background: url("~@/assets/images/website/home/communication.png") no-repeat;
  background-size: cover;
  padding-top: 73px;
  padding-bottom: 60px;

  .app-header {
    font-family: PingFangSC-Regular;
    font-size: 36px;
    color: #2A313B;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    margin-bottom: 53px
  }

  .communication-card {
    width: 1280px;
    margin: 0 auto;
    height: 500px;
  }

  .card-content {
    display: flex;
    margin-right: 16px;
  }

  @keyframes axisX {
    from {
      transform: translateX(100px);
    }

    to {
      transform: translateX(0px);
    }
  }

  @keyframes axisright {
    from {
      transform: translateX(-50px);
    }

    to {
      transform: translateX(0px);
    }
  }

}
</style>
